// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card[data-v-55bfce30]{border-radius:8px}.headline[data-v-55bfce30]{color:#424242}a[data-v-55bfce30]{text-decoration:none;color:#1976d2}a[data-v-55bfce30]:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
